import { ColDef, GridApi } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";

interface Params {
  gridRef: React.RefObject<AgGridReact<any>>;
  setFilteredRowsForPrint: (value: React.SetStateAction<any[]>) => void;
  rows: any[];
}

export const handlePrintFilteredRows = ({
  gridRef,
  setFilteredRowsForPrint,
  rows,
}: Params) => {
  const api = gridRef.current?.api as GridApi<any>;
  const filterModel = api.getFilterModel();
  const columnDefs = api.getColumnDefs();

  const filtered = rows.filter((row) => {
    return Object.entries(filterModel).every(([field, filter]) => {
      const colDef = columnDefs?.find(
        (col): col is ColDef<any> => "field" in col && col.field === field
      );
      if (!colDef) return true;

      const value = row[field as keyof any];

      if (filter.filterType === "text") {
        if (filter.type === "contains") {
          return String(value)
            .toLowerCase()
            .includes(filter.filter.toLowerCase());
        } else if (filter.type === "equals") {
          return String(value).toLowerCase() === filter.filter.toLowerCase();
        }
      }

      if (filter.filterType === "number") {
        const num = Number(value);
        const filterNum = Number(filter.filter);
        if (filter.type === "equals") return num === filterNum;
        if (filter.type === "greaterThan") return num > filterNum;
        if (filter.type === "lessThan") return num < filterNum;
      }

      return true;
    });
  });

  setFilteredRowsForPrint(filtered);
};
